import apiClient from "./config";
import { TEAM_ENDPOINTS } from "./endpoints";

export const getTeamData = (team) => apiClient.get(TEAM_ENDPOINTS.GET_TEAMDATA, team);
export const deleteTeamData = (team) => apiClient.delete(TEAM_ENDPOINTS.DELETE_TEAMDATA, { headers: { team } });
export const addTeamData = (team) => apiClient.create(TEAM_ENDPOINTS.ADD_NEW_TEAMDATA, team);
export const updateTeamData = (team) => apiClient.put(TEAM_ENDPOINTS.UPDATE_TEAMDATA, team);

